export enum ProgramDropdownNameEnum {
  NAME_ASC = 'Name: A-Z',
  NAME_DESC = 'Name: Z-A',
  CREATED_NEWEST = 'Program Year: Newest First',
  CREATED_OLDEST = 'Program Year: Oldest First',
}
